




































































































import { Vue, Component } from 'vue-property-decorator';

import stepAnimation from '@/assets/animations/how_it_works.svg';
import stepImage from '@/assets/images/how_it_works.svg';
import appStoreLogo from '@/assets/logos/logo_app_store.svg';
import googlePlayLogo from '@/assets/logos/logo_google_play.svg';

@Component({
  name: 'StepSection',
  components: {
  },
})
/**
 * @vuese
 * @group Page/StepSection
 * StepSection component
 */
export default class StepSection extends Vue {
  // [data]
  showAnimation = true;
  stepAnimation: string = '';
  stepImage: string = stepImage;
  appStoreLogo: string = appStoreLogo;
  googlePlayLogo: string = googlePlayLogo;

  // [method]
  howItWorksAnimation(event: Event, el: any) {
    if (this.stepAnimation === '') {
      const rect = el.getBoundingClientRect();
      const inView = (
        rect.width > 0 && rect.height > 0 && rect.top >= -200
        && rect.bottom - 200 <= (window.innerHeight || document.documentElement.clientHeight)
      );
      if (inView) this.stepAnimation = stepAnimation;
    }
  }

  getOs() {
    var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', ''],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

    if (iosPlatforms.indexOf(platform) !== -1
      || userAgent.indexOf(iosPlatforms[0]) !== -1 
      || userAgent.indexOf(iosPlatforms[1]) !== -1
      || userAgent.indexOf(iosPlatforms[2]) !== -1) {
      os = 'iOS';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'MacOS';
    }
    return os;
  }

  // [lifecycle]
  created() {
    if (window.innerWidth <= 960) this.showAnimation = false;
  }
}

// [directive]
Vue.directive('scroll', {
  inserted: (el, binding) => {
    const f = (evt: any) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});
